import getCompany from "./getCompany";
import createCompany from "./createCompany";
import updateCompany from "./updateCompany";
import deleteCompany from "./deleteCompany";

export { getCompany, createCompany, updateCompany, deleteCompany };

export default { getCompany, createCompany, updateCompany, deleteCompany };
